import React, { useState,useEffect } from "react";
import Base from "../Employee_components/Employee_Base";
import { Breadcrumbs, Link, Button } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
//import { Table, Tbody, Tr, Td } from "react-super-responsive-table";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import "../Employee Section/EmployeeList.css";
import { EMPLOYEE_API_BASE_URL } from "../Auth/Api";
import { useAuth } from "../Auth/AuthContext";
import UseAxios from "../Auth/UseAxios";
import Swal from "sweetalert2";

const EmployeeWalletAmount = () => {
  const [withdrawAmount, setWithdrawAmount] = useState("");
  const [incentiveAmount,setIncentiveAmount] = useState(0);
   const navigate = useNavigate(); // State to hold input 
   const api = UseAxios();
   const { employee } = useAuth();

  // Function to reset the input field
  const handleCancel = () => {
    setWithdrawAmount(""); // Reset the state to empty
    navigate("/employee/dashboard")
  };



  useEffect(() => {
          const fetchWithDrawAmount = async () => {
            try {
              const response = await api.get(`${EMPLOYEE_API_BASE_URL}/employee/employee/incentives/${employee.employeeReferenceId}`);
              setIncentiveAmount(response.data);
              console.log(response.data);
            } catch (error) {
              console.error("Error fetching employees:", error);
            }
          };
        
          fetchWithDrawAmount();
        }, [employee.employeeReferenceId]); 


        const handleWithdrawRequest = async () => {
          try {
            const employeeData = JSON.parse(localStorage.getItem("employeeData"));
            const employeeReferenceId = employeeData?.employeeReferenceId;
       
            if (!employeeReferenceId) {
              console.error("Employee reference ID not found");
              return;
            }
       
            // Make a POST request using request parameters instead of body
            const response = await api.post(
              `${EMPLOYEE_API_BASE_URL}/employee/withdraw?withdrawAmount=${withdrawAmount}`
            );
       
            Swal.fire({
              title: `Withdraw Request`,
              text: `Your withdraw request is accepted`,
              icon: "success",
            });
       
            setWithdrawAmount("");
          } catch (error) {
            console.error("Error submitting withdrawal request:", error);
            Swal.fire({
              title: "Error",
              text: "Failed to submit withdrawal request. Please try again.",
              icon: "error",
            });
          }
        };
       
        const isWithdrawDisabled = !withdrawAmount || parseFloat(withdrawAmount) <= 0 || parseFloat(withdrawAmount)> incentiveAmount.incentiveAmount;
       
  return (
    <Base>
      {/* Breadcrumbs Navigation */}
      <div
        className="pt-3 mt-5"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          paddingRight: "20px",
        }}
      >
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          <Link
            color="inherit"
            href="/employee/dashboard"
            sx={{ color: "blue", fontWeight: "bold" }}
          >
            Dashboard 
          </Link>
          <Link underline="none" color="inherit" href="/employee/employee_wallet_amount" sx={{ color: "darkslategrey", fontWeight: "bold" }}>
            EmployeeWallet
          </Link>
        </Breadcrumbs>
      </div>

      {/* Title */}
      <h2 className="text-center fw-bold fs-1" style={{ color: "darkslategrey" }}>
        Employee Wallet Amount
      </h2>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <hr style={{ width: "90%" }} />
      </div>

      {/* Wallet Amount Table */}
      <div className="container" >
        <table className="wallet-table table-responsive">
          <tbody className="fw-bold">
            <tr>
              <td>Incentive Amount available for withdrawal</td>
              <td>{Math.round(incentiveAmount.incentiveAmount).toLocaleString()}</td>
            </tr>
            <tr>
              <td>Select Wallet Amount for withdrawal</td>
              <td style={{padding:"10px"}}>
                <input
                  type="number"
                  placeholder="Enter Amount"
                  value={withdrawAmount} // Bind input value to state
                  onChange={(e) => setWithdrawAmount(e.target.value)} // Update state on change
                  style={{
                    width: "100%",
                    padding: "8px",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                  }}
                />
              </td>
            </tr>
            <tr>
              <td colSpan="2">
            <div style={{ display: "flex",alignContent:"center",justifyContent:"center",gap:"10px",padding:"10px"}}>
          <Button
            variant="contained"
            color="primary"
            sx={{  backgroundColor: "green" }}
            disabled={isWithdrawDisabled}
            onClick={handleWithdrawRequest}
          >
            Withdraw Request
          </Button>
          <Button
            variant="contained"
            color="secondary"
            sx={{ backgroundColor: "red" }}
            onClick={handleCancel} // Reset input when Cancel is clicked
          >
            Cancel
          </Button>
        </div>
        </td>
            </tr>
          </tbody>
        </table>

      </div>
    </Base>
  );
};

export default EmployeeWalletAmount;
